import SourceItem from "./SourceItem";


class TargetItem {

    constructor() {
        this.targetTxt = "";
        this.targetImg = "default.png";
        this.hasExternalUrl = false
        this.targetIndex = -1
        this.sourceItemList = []
        this.solvedSourceItemList = []
        this.htmlRef = null
    }

    getAsJson = () => {
        let obj = {}
        obj.targetTxt = this.targetTxt
        obj.targetIndex = this.targetIndex
        obj.targetImg = this.targetImg
        obj.hasExternalUrl = this.hasExternalUrl

        obj.solvedSourceItemList = []
        for (let i = 0; i < this.solvedSourceItemList.length; i++) {
            obj.solvedSourceItemList.push(this.solvedSourceItemList[i].getAsJson())
        }
        return obj
    }


    initFromJson = (obj) => {
        this.targetTxt = obj.targetTxt
        this.targetIndex = obj.targetIndex
        this.targetImg = obj.targetImg
        this.hasExternalUrl = obj.hasExternalUrl
        for (let i = 0; i < obj.solvedSourceItemList.length; i++) {
            let sourceItem = new SourceItem()
            sourceItem.initFromJson(obj.solvedSourceItemList[i])
            this.solvedSourceItemList.push(sourceItem)
        }
    }

    addSourceItem = (sourceItem) => {

        let obj = sourceItem.getAsJson()
        let newsourceItem = new SourceItem()
        newsourceItem.initFromJson(obj)
        this.sourceItemList.push(newsourceItem)
    }

    removeSourceItem = (sourceItem) => {

        let index = -1;
        for (let i = 0; i < this.sourceItemList.length; i++) {
            if (sourceItem.sourceIndex == this.sourceItemList[i].sourceIndex) {

                index = i
                break
            }
        }

        if (index != -1) {
            this.sourceItemList.splice(index, 1)
        }
    }


    selectSourceItem = (sourceItem) => {

        if (this.contains(sourceItem)) {
            this.removeSourceItem(sourceItem)
        }
        else {
            this.addSourceItem(sourceItem)
        }
    }

    contains = (sourceItem) => {
        for (let i = 0; i < this.sourceItemList.length; i++) {
            if (sourceItem.sourceIndex == this.sourceItemList[i].sourceIndex)
                return true
        }

        return false
    }
}

export default TargetItem